export default __webpack_public_path__ + "static/media/bathroom-up.4ead6269.mp4";